<template>
  <section class="accordion-list-block">
    <div class="accordion-list-block__card">
      <div class="paid-accordion">
        <div
          v-for="(section, sectionIndex) in displaySections"
          :key="'s-' + sectionIndex"
          class="paid-accordion__item"
          :class="{ 'accordion-list-block__item--highlight': section.anchor && highlightedAnchor === section.anchor }"
          :id="section.anchor || undefined"
        >
          <button
            type="button"
            class="paid-accordion__btn"
            :aria-expanded="isOpen(sectionKey(sectionIndex)) ? 'true' : 'false'"
            @click="toggle(sectionKey(sectionIndex))"
          >
            <span class="paid-accordion__btn-left">
              <span
                v-if="section.icon"
                class="paid-accordion__icon"
                aria-hidden="true"
              >
                <img class="paid-accordion__icon-img" :src="section.icon" alt="" />
              </span>
              <span class="accordion-list-block__heading">
                <span class="paid-accordion__name">{{ section.title || 'Без заголовка' }}</span>
                <span
                  v-if="section.note"
                  class="accordion-list-block__note"
                >{{ section.note }}</span>
              </span>
            </span>
            <span
              class="paid-accordion__chevron"
              :class="{ 'is-open': isOpen(sectionKey(sectionIndex)) }"
              aria-hidden="true"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20">
                <path fill="currentColor" d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"/>
              </svg>
            </span>
          </button>

          <div
            v-if="isOpen(sectionKey(sectionIndex))"
            class="paid-accordion__panel"
            :class="{
              'accordion-list-block__panel': !section.icon,
              'accordion-list-block__panel--with-icon': !!section.icon,
            }"
          >
            <!-- 2-й уровень: подсписки -->
            <div
              v-if="section.children.length"
              class="paid-accordion accordion-list-block__nested"
            >
              <div
                v-for="(child, childIndex) in section.children"
                :key="'c-' + sectionIndex + '-' + childIndex"
                class="paid-accordion__item"
                :class="{ 'accordion-list-block__item--highlight': child.anchor && highlightedAnchor === child.anchor }"
                :id="child.anchor || undefined"
              >
                <button
                  type="button"
                  class="paid-accordion__btn"
                  :aria-expanded="isOpen(childKey(sectionIndex, childIndex)) ? 'true' : 'false'"
                  @click="toggle(childKey(sectionIndex, childIndex))"
                >
                  <span class="paid-accordion__btn-left">
                    <span
                      v-if="child.icon"
                      class="paid-accordion__icon paid-accordion__icon--nested"
                      aria-hidden="true"
                    >
                      <img class="paid-accordion__icon-img" :src="child.icon" alt="" />
                    </span>
                    <span class="accordion-list-block__heading">
                      <span class="paid-accordion__name">{{ child.title || 'Без заголовка' }}</span>
                      <span
                        v-if="child.note"
                        class="accordion-list-block__note"
                      >{{ child.note }}</span>
                    </span>
                  </span>
                  <span
                    class="paid-accordion__chevron"
                    :class="{ 'is-open': isOpen(childKey(sectionIndex, childIndex)) }"
                    aria-hidden="true"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20">
                      <path fill="currentColor" d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"/>
                    </svg>
                  </span>
                </button>
                <div
                  v-if="isOpen(childKey(sectionIndex, childIndex))"
                  class="paid-accordion__panel"
                  :class="{
                    'accordion-list-block__panel': !child.icon,
                    'accordion-list-block__panel--with-icon': !!child.icon,
                    'accordion-list-block__panel--nested': true,
                  }"
                >
                  <!-- 3-й уровень -->
                  <div
                    v-if="child.children.length"
                    class="paid-accordion accordion-list-block__nested accordion-list-block__nested--l3"
                  >
                      <div
                        v-for="(gc, gIdx) in child.children"
                        :key="'g-' + sectionIndex + '-' + childIndex + '-' + gIdx"
                        class="paid-accordion__item"
                        :class="{ 'accordion-list-block__item--highlight': gc.anchor && highlightedAnchor === gc.anchor }"
                        :id="gc.anchor || undefined"
                      >
                      <button
                        type="button"
                        class="paid-accordion__btn"
                        :aria-expanded="isOpen(grandchildKey(sectionIndex, childIndex, gIdx)) ? 'true' : 'false'"
                        @click="toggle(grandchildKey(sectionIndex, childIndex, gIdx))"
                      >
                        <span class="paid-accordion__btn-left">
                          <span
                            v-if="gc.icon"
                            class="paid-accordion__icon paid-accordion__icon--nested paid-accordion__icon--l3"
                            aria-hidden="true"
                          >
                            <img class="paid-accordion__icon-img" :src="gc.icon" alt="" />
                          </span>
                          <span class="accordion-list-block__heading">
                            <span class="paid-accordion__name">{{ gc.title || 'Без заголовка' }}</span>
                            <span
                              v-if="gc.note"
                              class="accordion-list-block__note"
                            >{{ gc.note }}</span>
                          </span>
                        </span>
                        <span
                          class="paid-accordion__chevron"
                          :class="{ 'is-open': isOpen(grandchildKey(sectionIndex, childIndex, gIdx)) }"
                          aria-hidden="true"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20">
                            <path fill="currentColor" d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"/>
                          </svg>
                        </span>
                      </button>
                      <div
                        v-if="isOpen(grandchildKey(sectionIndex, childIndex, gIdx))"
                        class="paid-accordion__panel"
                        :class="{
                          'accordion-list-block__panel': !gc.icon,
                          'accordion-list-block__panel--with-icon': !!gc.icon,
                          'accordion-list-block__panel--nested': true,
                          'accordion-list-block__panel--l3': true,
                        }"
                      >
                        <ul
                          v-if="gc.items.length"
                          class="paid-service-list"
                        >
                          <li
                            v-for="(item, itemIndex) in gc.items"
                            :key="itemIndex"
                            class="paid-service-row"
                          >
                            <BelyashiEggText
                              v-if="isBelyashiEggText(item)"
                              class="paid-service-row__name"
                              :text="item"
                            />
                            <span v-else class="paid-service-row__name">{{ item }}</span>
                          </li>
                        </ul>
                        <p
                          v-else
                          class="accordion-list-block__empty"
                        >
                          Пункты списка не заданы
                        </p>
                      </div>
                    </div>
                  </div>

                  <!-- L2: плоские пункты -->
                  <template v-else>
                    <ul
                      v-if="child.items.length"
                      class="paid-service-list"
                    >
                      <li
                        v-for="(item, itemIndex) in child.items"
                        :key="itemIndex"
                        class="paid-service-row"
                      >
                        <BelyashiEggText
                          v-if="isBelyashiEggText(item)"
                          class="paid-service-row__name"
                          :text="item"
                        />
                        <span v-else class="paid-service-row__name">{{ item }}</span>
                      </li>
                    </ul>
                    <p
                      v-else
                      class="accordion-list-block__empty"
                    >
                      Пункты списка не заданы
                    </p>
                  </template>
                </div>
              </div>
            </div>

            <!-- 1 уровень: плоские пункты (legacy) -->
            <template v-else>
              <ul
                v-if="section.items.length"
                class="paid-service-list"
              >
                <li
                  v-for="(item, itemIndex) in section.items"
                  :key="itemIndex"
                  class="paid-service-row"
                >
                  <BelyashiEggText
                    v-if="isBelyashiEggText(item)"
                    class="paid-service-row__name"
                    :text="item"
                  />
                  <span v-else class="paid-service-row__name">{{ item }}</span>
                </li>
              </ul>
              <p
                v-else
                class="accordion-list-block__empty"
              >
                Пункты списка не заданы
              </p>
            </template>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import BelyashiEggText from '@/components/EasterEggs/BelyashiEggText.vue'
import { isBelyashiEggText } from '@/components/EasterEggs/belyashiEgg'

function textItems(raw) {
  if (!Array.isArray(raw)) return [];
  return raw.map((i) => String(i || '').trim()).filter(Boolean);
}

function normalizeGrandchild(g) {
  return {
    title: (g && g.title) ? String(g.title) : '',
    note: (g && g.note) ? String(g.note).trim() : '',
    icon: (g && g.icon) ? String(g.icon).trim() : '',
    anchor: (g && g.anchor) ? String(g.anchor).trim() : '',
    defaultOpen: !!(g && (g.defaultOpen === true || g.defaultOpen === 'true')),
    items: textItems(g && g.items),
  };
}

function normalizeChild(c) {
  const childrenRaw = (c && Array.isArray(c.children)) ? c.children : [];
  const children = childrenRaw
    .map(normalizeGrandchild)
    .filter((g) => g.title.trim() || g.items.length);
  return {
    title: (c && c.title) ? String(c.title) : '',
    note: (c && c.note) ? String(c.note).trim() : '',
    icon: (c && c.icon) ? String(c.icon).trim() : '',
    anchor: (c && c.anchor) ? String(c.anchor).trim() : '',
    defaultOpen: !!(c && (c.defaultOpen === true || c.defaultOpen === 'true')),
    items: textItems(c && c.items),
    children,
  };
}

export default {
  name: 'AppAccordionListBlock',
  components: { BelyashiEggText },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      opened: {},
      highlightedAnchor: '',
    };
  },
  computed: {
    displaySections() {
      const raw = this.data && Array.isArray(this.data.sections)
        ? this.data.sections
        : [];
      return raw
        .map((s) => {
          const childrenRaw = (s && Array.isArray(s.children)) ? s.children : [];
          const children = childrenRaw
            .map(normalizeChild)
            .filter((c) => c.title.trim() || c.items.length || c.children.length);
          return {
            title: (s && s.title) ? String(s.title) : '',
            note: (s && s.note) ? String(s.note).trim() : '',
            icon: (s && s.icon) ? String(s.icon).trim() : '',
            anchor: (s && s.anchor) ? String(s.anchor).trim() : '',
            defaultOpen: !!(s && (s.defaultOpen === true || s.defaultOpen === 'true')),
            items: textItems(s && s.items),
            children,
          };
        })
        .filter((s) => s.title.trim() || s.items.length || s.children.length);
    },
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.initOpenedState();
          this.$nextTick(() => this.openByHash());
        });
      },
    },
    '$route.hash': {
      handler() {
        this.$nextTick(() => this.openByHash());
      },
    },
  },
  mounted() {
    this.initOpenedState();
    this.$nextTick(() => this.openByHash());
  },
  methods: {
    isBelyashiEggText,
    sectionKey(sectionIndex) {
      return `s-${sectionIndex}`;
    },
    childKey(sectionIndex, childIndex) {
      return `s-${sectionIndex}-c-${childIndex}`;
    },
    grandchildKey(sectionIndex, childIndex, gIdx) {
      return `s-${sectionIndex}-c-${childIndex}-g-${gIdx}`;
    },
    initOpenedState() {
      const next = {};
      this.displaySections.forEach((s, i) => {
        const sk = this.sectionKey(i);
        next[sk] = !!s.defaultOpen;
        s.children.forEach((c, j) => {
          const ck = this.childKey(i, j);
          next[ck] = !!c.defaultOpen;
          c.children.forEach((g, k) => {
            const gk = this.grandchildKey(i, j, k);
            next[gk] = !!g.defaultOpen;
          });
        });
      });
      this.opened = next;
    },
    toggle(key) {
      this.$set(this.opened, key, !this.isOpen(key));
    },
    isOpen(key) {
      return !!this.opened[key];
    },
    openByHash() {
      const hash = typeof window !== 'undefined' && (this.$route.hash || window.location.hash);
      if (!hash || hash.length < 2) return;
      const target = hash.startsWith('#') ? hash.slice(1) : hash;
      const data = this.displaySections;
      const highlight = (anchor) => {
        this.highlightedAnchor = anchor;
        setTimeout(() => {
          if (this.highlightedAnchor === anchor) {
            this.highlightedAnchor = '';
          }
        }, 2500);
        this.$nextTick(() => this.scrollToElement(anchor));
      };
      for (let i = 0; i < data.length; i++) {
        const s = data[i];
        if (s.anchor === target) {
          this.$set(this.opened, this.sectionKey(i), true);
          highlight(target);
          return;
        }
        for (let j = 0; j < s.children.length; j++) {
          const c = s.children[j];
          if (c.anchor === target) {
            this.$set(this.opened, this.sectionKey(i), true);
            this.$set(this.opened, this.childKey(i, j), true);
            highlight(target);
            return;
          }
          for (let k = 0; k < c.children.length; k++) {
            const g = c.children[k];
            if (g.anchor === target) {
              this.$set(this.opened, this.sectionKey(i), true);
              this.$set(this.opened, this.childKey(i, j), true);
              this.$set(this.opened, this.grandchildKey(i, j, k), true);
              highlight(target);
              return;
            }
          }
        }
      }
    },
    scrollToElement(id) {
      const el = document.getElementById(id);
      if (el && typeof el.scrollIntoView === 'function') {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.accordion-list-block {
  padding: 0 0 20px;
}

.accordion-list-block__card {
  max-width: 1650px;
  margin: 0 auto;
  font-family: 'Circe', Arial, sans-serif;
  background-color: white;
  border-radius: 20px;
  padding: 0;
  overflow: hidden;
}

.accordion-list-block .paid-accordion__btn-left {
  align-items: flex-start;
}

.accordion-list-block__heading {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.accordion-list-block__note {
  font-family: 'Circe', Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: #888;
}

.accordion-list-block .paid-accordion__chevron {
  align-self: center;
  flex-shrink: 0;
}

/* Компактнее по вертикали; без лишнего горизонтального padding */
.accordion-list-block .paid-accordion__btn {
  padding: 10px 0;
}

/* Без иконки — без отступа 58px как на прайсе */
.accordion-list-block__panel {
  padding-left: 0;
}

/* С иконкой — как paid-accordion__panel */
.accordion-list-block__panel--with-icon {
  padding-left: 58px;
}

.accordion-list-block__panel--nested {
  padding-bottom: 8px;
}

.accordion-list-block__panel--l3.accordion-list-block__panel--with-icon {
  padding-left: 48px;
}

.accordion-list-block__nested {
  border-top: none;
}

.accordion-list-block__nested > .paid-accordion__item:first-child {
  border-top: none;
}

.accordion-list-block .paid-accordion__icon--nested {
  width: 44px;
  height: 44px;
  border-radius: 10px;
}

.accordion-list-block .paid-accordion__icon--l3 {
  width: 36px;
  height: 36px;
  border-radius: 8px;
}

.accordion-list-block__empty {
  margin: 0;
  padding: 4px 0 8px;
  font-family: 'Circe', Arial, sans-serif;
  font-size: 15px;
  color: #888;
}

.accordion-list-block__item--highlight {
  animation: accordion-highlight 2s ease-out;
}

@keyframes accordion-highlight {
  0% {
    background-color: rgba(0, 153, 167, 0.12);
  }
  60% {
    background-color: rgba(0, 153, 167, 0.04);
  }
  100% {
    background-color: transparent;
  }
}

@media (max-width: 1024px) {
  .accordion-list-block__card {
    padding: 0;
  }
}

@media (max-width: 780px) {
  .accordion-list-block__card {
    padding: 0;
    border-radius: 15px;
  }

  .accordion-list-block__panel--with-icon,
  .accordion-list-block__panel--l3.accordion-list-block__panel--with-icon {
    padding-left: 4px;
  }
}

@media (max-width: 480px) {
  .accordion-list-block__card {
    padding: 0;
    border-radius: 12px;
  }
}
</style>
